export default "__VITE_ASSET__517865d2__"